import backbtn from '../../../assets/images/Dashboard/back-btn.svg'
import { Button, Col, Dropdown, Row } from 'react-bootstrap';
import dashboardLibrary from '../../../assets/images/Sidebar/dashboardLibrary.svg'
import saveCustomView from '../../../assets/images/Sidebar/saveCustomView.svg'
import chevronDown from '../../../assets/images/Sidebar/chevron-down-white.svg'
import { useEffect, useState } from 'react';
import SaveCustomeViewModal from '../../ContentSection/DashBoard/SaveCustomeViewModal';
import { loadCustomDashboards, loadCustomviews } from '../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import edit from '../../../assets/images/Dashboard/edit-img.svg';

const Download = (props) => {

    const { customViews = [] } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const signInType = signInDetails?.[0]?.SignInType;

    const signInId =
        signInType === "SuperAdmin"
            ? signInDetails?.[0]?.SuperAdminID
            : signInType === "ClientAdmin"
                ? signInDetails?.[0]?.CompanyID
                : signInType === "User"
                    ? signInDetails?.[0]?.UserID
                    : null;

    const { customDashboards = [] } = useSelector((state) => state.data);
    // const customViews = props.customViews;

    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [customDashboardId, setCustomDashboardId] = useState('');
    // const pdfRef = useRef(null);

    const loadAllGraphsForModal = () => {
        dispatch(loadCustomviews(null, signInType, signInId, getModuleID()));
    };

    const handleOpenModal = (CustomDashboardID) => {
        setCustomDashboardId(CustomDashboardID)
        dispatch(loadCustomviews(CustomDashboardID));
        setIsModalOpen(true);
        // loadAllGraphsForModal();
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // Logic to determine if the Analytics button should be visible
    // const showAnalytics = props.SignInType !== 'User';

    const getModuleID = () => {
        if (currentPath === "/dashboard") return 2;
        if (currentPath === "/licenceDashboard") return 3;
        if (currentPath === "/complaintDashboard") return 5;
        if (currentPath === "/slaDashboard") return 6;
        if (currentPath === "/attendanceDashboard") return 4;
        return null; // fallback or default
    };

    const currentPath = window.location.pathname;

    // useEffect(() => {
    //     // Get the ModuleID based on the current path
    //     const moduleID = getModuleID();

    //     // Dispatch the loadCustomDashboards action with the dynamic ModuleID
    //     dispatch(loadCustomDashboards(moduleID));
    // }, [dispatch, currentPath]);  // Ensure to re-run when currentPath changes

    const loadDashboardsByPath = () => {
        const moduleID = getModuleID();
        dispatch(loadCustomDashboards(moduleID));
    };

    useEffect(() => {
        loadDashboardsByPath();
    }, [dispatch, currentPath]);

    const handleCustomDashboardClick = (CustomDashboardID) => {
        // Dispatch the action to load the custom views with the CustomDashboardID
        dispatch(loadCustomviews(CustomDashboardID));
        // Pass the selected ID to parent
        if (props.onCustomDashboardSelect) {
            props.onCustomDashboardSelect(CustomDashboardID);
        }
    };

    // const isEditMode = customDashboards?.some(
    //     (dash) => dash.SignInType === signInType && dash.SignInID === signInId
    // );

    const editableDashboard = customDashboards.find(
        (dash) => dash.SignInType === signInType && dash.SignInID === signInId
    );
    const isEditMode = !!editableDashboard;

    let CompanyID = null;
    let SignInType = null;

    if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
        CompanyID = signInDetails?.[0]?.SuperAdminID;
        SignInType = signInDetails[0].SignInType;
    } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
        CompanyID = signInDetails?.[0]?.CompanyID;
        SignInType = signInDetails[0].SignInType;
    } else if (signInDetails?.[0]?.SignInType === "User") {
        CompanyID = signInDetails?.[0]?.UserID;
        SignInType = signInDetails[0].SignInType;
    }

    return (
        <Row className='download-btn-container m-0'>
            <Col md={5} className='backbtn-div'>
                <div className='back-navigation-div' onClick={props.onBackClick}>
                    {props.showBackButton && (
                        <img src={backbtn} alt="Back Button" />
                    )}&nbsp;&nbsp;
                    <span>{props.moduleName}</span>
                </div>
            </Col>
            <Col md={7} className='p-0 download-header-btns'>
                <div className='header-btns'>
                    {props.showDashboardLibraryButton && (
                        <Button onClick={props.onClick}>
                            Dashboard Library
                            &nbsp;&nbsp;<img src={dashboardLibrary} alt="" />
                        </Button>
                    )}

                    {/* Conditionally render the Save Custom View button */}
                    {/* {props.showSaveCustomViewButton && (
                        <Button onClick={handleOpenModal}>
                            Custom View
                            &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                        </Button>
                    )} */}
                    {/* {props.showAnalyticsButton && (
                        <Button onClick={props.onClick}>
                            Analytics
                            &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                        </Button>
                    )} */}
                    {
                        // showAnalytics && 
                        props.showAnalyticsButton && (
                            <Button onClick={props.onClick}>
                                Analytics &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                            </Button>
                        )}
                    {props.showCustomViewDropdown && (
                        <Dropdown>
                            <Dropdown.Toggle as={Button} variant="light" className="download-btn">
                                Custom View
                                &nbsp;&nbsp;<img src={chevronDown} alt="Chevron Down" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='download-dropdown-Options save-custom-options'>
                                {/* Map over customDashboards to display each CustomDashboardName */}
                                {customDashboards && customDashboards.map((dashboard) => (
                                    <Dropdown.Item key={dashboard.CustomDashboardID} onClick={() => handleCustomDashboardClick(dashboard.CustomDashboardID)}>
                                        {(dashboard.SignInID === CompanyID && dashboard.SignInType === SignInType) &&
                                            <img
                                                src={edit}
                                                alt="Edit"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOpenModal(dashboard.CustomDashboardID);
                                                }}
                                            />
                                        }
                                        &nbsp; {dashboard.CustomDashboardName}
                                    </Dropdown.Item>
                                ))}

                                {/* <Dropdown.Divider /> */}
                                {/* <Dropdown.Item style={{ color: "rgba(6, 201, 244, 1)" }} onClick={() => { handleOpenModal(isEditMode ? editableDashboard?.CustomDashboardID : null) }}>{isEditMode ? "Edit Custom View" : "Create Custom View"}</Dropdown.Item> */}
                                <Dropdown.Item style={{ color: "rgba(6, 201, 244, 1)" }} onClick={() => { handleOpenModal() }}> Create Custom View</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                    {props.showDownloadDropdown && (
                        <Dropdown>
                            <Dropdown.Toggle as={Button} variant="light" className="download-btn">
                                Download
                                &nbsp;&nbsp;<img src={chevronDown} alt="Chevron Down" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='download-dropdown-Options'>
                                <Dropdown.Item onClick={props.onImageClick}>Images</Dropdown.Item>
                                <Dropdown.Item onClick={props.onPdfDownloadClick}>PDF</Dropdown.Item>
                                <Dropdown.Item onClick={props.onExcelDownloadClick}>Excel</Dropdown.Item>
                                <Dropdown.Item onClick={props.onWordDownloadClick}>Word Document</Dropdown.Item>
                                <Dropdown.Item onClick={props.onPrintClick}>Print</Dropdown.Item>
                                <Dropdown.Item onClick={props.onEmailCsvClick}>Attach as Email</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </div>
            </Col>
            {
                isModalOpen && <SaveCustomeViewModal
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    customViews={customViews}
                    customDashboardId={customDashboardId}
                    loadDashboardsByPath={loadDashboardsByPath}
                />
            }
        </Row>
    );
}

export default Download;